
/* injects from baggage-loader */

import React, { Component } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { withRouter } from 'react-router';
import HorseRacingEvent from "../horseRacingEvent";
import GreyhoundsEvent from "../greyhoundsEvent";
import { getHorseRacingData } from "../../../actions/horseRacing";
import Loader from '../loader';
import { getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { getSwarmSubscriptionRequestNextRacing } from "../../../helpers/terminalRequests/horseRacing";
import { t } from "../../../helpers/translator";

// eslint-disable-next-line camelcase
function createSort(sortByOrder, sortByPrice) {
    // const key = state ? 'price' : 'original_order';
    const keyOrder = sortByOrder && 'original_order';
    const keyPrice = sortByPrice && 'price';
    const keyPriceRevert = !sortByPrice && 'price';
    return function (a, b) {
        if (sortByOrder) {
            return (a[keyOrder] - b[keyOrder]);
        } else if (sortByPrice) {
            return (a[keyPrice] || Number.MAX_VALUE) - (b[keyPrice]|| Number.MAX_VALUE);
        }
        return (b[keyPriceRevert] - a[keyPriceRevert]);
    };
}

class HorseRacingEventWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trap: true,
            sortByOrder: false,
            sortByPrice: false,
            horseRacingMarket: 'winner'
        };
        this.setMarketTypeToggle = this.setMarketTypeToggle.bind(this);
        this.sortBy = this.sortBy.bind(this);
        this.onChangeMarket = this.onChangeMarket.bind(this);
    }

    onChangeMarket(market) {
        this.setState({
            horseRacingMarket: market
        });
    }

    //createSort(this.state.sortByOrder, this.state.sortByPrice)

    sortBy(sort) {
        sort ? this.setState({ sortByOrder: true }) : this.setState({ sortByPrice: !this.state.sortByPrice, sortByOrder: false });
    }

    setMarketTypeToggle() {
        this.setState({ trap: !this.state.trap });
    }
    componentDidMount () {
        const { gameInfo: {id, market = {}, creation_source} = {}, params: { sportId } = {} } = this.props;

        sportId === "31" && id && this.props.dispatch(getHorseRacingData(id, creation_source));
        this.timerId = setTimeout(() => {
            this.setState({ someLoading: true });
        }, 5000);
        const hasPrices = Object.values(Object.values(market)[0]?.event || {}).some(el => el.price)

        this.setState({
            sortByPrice: hasPrices,
            sortByOrder: !hasPrices
        });
    }
    componentDidUpdate (prevProps) {        
        const {horseInfo, nextRacing, gameInfo: {id, market = {}, creation_source} = {}, params: { sportId } = {}} = this.props;


        const data = Object.values(market).reduce((accumulator, current) => {
            Object.values(current.event).filter(item => this.state.horseRacingMarket === 'winner' || !['Favourite', '2nd Favourite'].includes(item.type)).forEach(item => {
                accumulator.push({ ...item, marketType: current.market_type, displayName: current.name_template, marketId: current.id });
            });

            return accumulator;
        }, []);

        if (!(data && data.length && (sportId === "184" || horseInfo)) && this.state.someLoading) {
            const { competitionId, regionId, id } = nextRacing
            const newUrl = sportId === 31 ? "/horseRacing/" : '/greyhounds/';

            this.props.router.push(`${newUrl}${sportId}/${regionId}/${competitionId}/${id}`)
        }

        if (sportId === "31" && id && prevProps.gameInfo.id !== id) {
            this.props.dispatch(getHorseRacingData(id, creation_source));
        }
        
        if (this.props.gameInfo !== prevProps.gameInfo) {
            const hasPrices = Object.values(Object.values(market)[0]?.event || {}).some(el => el.price)

            this.setState({
                sortByPrice: hasPrices,
                sortByOrder: !hasPrices
            });
        }
    }
    
    componentWillUnmount() {
        this.timerId && clearTimeout(this.timerId);
    }

    render () {
        const { gameInfo, horseInfo, params: { sportId } } = this.props;

        const data = Object.values(gameInfo.market || {}).reduce((accumulator, current) => {
            Object.values(current.event).filter(item => this.state.horseRacingMarket === 'winner' || !['Favourite', '2nd Favourite'].includes(item.type)).forEach(item => {
                accumulator.push({ ...item, marketType: current.market_type, displayName: current.name_template, marketId: current.id });
            });
            return accumulator;
        }, []);

        const marketData = {}

        data.filter(item => !['Winner', 'TrapWinner'].includes(item.marketType)).forEach(item => {
            if (!marketData[item.marketType] || item.marketType === 'matchBet') {
                if (item.marketType === 'matchBet') {
                    if (marketData[item.marketType]?.[item.marketId]) {
                        marketData[item.marketType][item.marketId].list.push(item)
                    } else {
                        marketData[item.marketType] = {
                            ...marketData[item.marketType],
                            name: item.displayName,
                            original_order: item.original_order,
                            marketType: item.marketType,
                            [item.marketId]: {
                                name: item.displayName,
                                original_order: item.original_order,
                                marketType: item.marketType,
                                list: [item]   
                            }
                        }
                    }
                } else {
                    marketData[item.marketType] = {
                        name: item.displayName,
                        original_order: item.original_order,
                        marketType: item.marketType,
                        list: [item]
                    }
                }
            } else {
                marketData[item.marketType].list.push(item)
            }
        })

        const status = gameInfo.info?.horse_xml.Status
        const currentMarketOriginalOrder = marketData[this.state.horseRacingMarket]?.original_order 
        const hasPicture = ((currentMarketOriginalOrder >= 1 && currentMarketOriginalOrder <= 6)
            || ['winner', 'forecast', 'tricast'].includes(this.state.horseRacingMarket))
        const showEachWayInfo = this.state.horseRacingMarket === 'winner'

        // console.log(Object.values(gameInfo.market)[0].extra_info, "---------------------------------OOOOOOOOOOOOOOOOOOOO");
        // const marketId = gameInfo ? Object.keys(gameInfo.market || {})[0] : '';
        // const eachWayInfo = Object.values(gameInfo.market)[0].extra_info;
        // console.log(eachWayInfo, "---------------------------------eachWayInfo");
        if ((data && data.length && (sportId === "184" ? true : horseInfo)) || this.state.someLoading) {
            if (!(data && data.length && (sportId === "184" ? true : horseInfo)) && this.state.someLoading) {
                return <div>{t("Game is not available")}</div>;
            }
            if (gameInfo.creation_source && gameInfo.sport_alias !== "SISGreyhound") {
                data.forEach(e => { e.isFavouriteType = (e.type === "Favourite" || e.type === "2nd Favourite"); });
                const fullData = data.map((data) => ({ ...(horseInfo.find(item => item.name.replace(/\s/g, '').toLowerCase() === data.type.replace(/\s/g, '').toLowerCase()) || {}), ...data }));
                const noPrice = fullData.map(newData => {
                    if (newData.price) {
                        return true;
                    } else {
                        return false;
                    }
                });

                return <div className="racing-h-list-v ">
                    <div className="racing-h-list-v-title">
                        <div className="racing-h-comp racing-icon">
                            <p className="racing-icon-p"><span className={`flag-view-m icon-${gameInfo.region_alias.toLowerCase()}`}></span></p>
                            <p className="racing-h-comp-team-p">{gameInfo.team1_name}</p>
                            {
                                showEachWayInfo &&
                                    <p className={'each-way-info'}>Each Way:
                                        <span> 1/{Object.values(gameInfo.market)[0].extra_info?.EachWayK}</span>
                                        <span> {Object.values(gameInfo.market)[0].extra_info?.EachWayPlace} Places</span>
                                    </p>
                            }
                            {
                                status &&
                                    <p className='status'>
                                        Status: { status }
                                    </p>
                            }
                        </div>
                        <div className="market-selectors">
                            <p className={`selector ${this.state.horseRacingMarket === 'winner' && 'activeMarket'}`}
                                onClick={() => this.onChangeMarket('winner')}
                            >
                                <span>{t("Winner")}</span>
                            </p>
                            {
                                (gameInfo.game_info.IsForecastAvailable || gameInfo.game_info.IsTricastAvailable) &&
                                <p className={`selector ${this.state.horseRacingMarket === 'forecast' && 'activeMarket'}`}
                                    onClick={() => this.onChangeMarket('forecast')}>
                                    <span>{t("Forecast")}</span>
                                </p>
                            }
                            {
                                gameInfo.game_info.IsTricastAvailable &&
                                <p className={`selector ${this.state.horseRacingMarket === 'tricast' && 'activeMarket'}`}
                                    onClick={() => this.onChangeMarket('tricast')}>
                                    <span>{t("Tricast")}</span>
                                </p>
                            }
                        </div>
                    </div>
                    <ul>
                        <li>
                            <p onClick={() => this.sortBy(true)}>{t("NO.")}</p>
                        </li>
                        <li>
                            <p>{t("SILIK")}</p>
                        </li>
                        <li>
                            <p>{t("HORSE")}</p>
                        </li>
                        <li>
                            <p>{t("TRAINER/JOCKEY")}</p>
                        </li>
                        {this.state.horseRacingMarket === 'winner' &&
                        <>
                            <li className={`horse-c-w price ${!noPrice.includes(true) && 'no-price'}`}>
                                <p onClick={() => noPrice.includes(true) && this.sortBy(false)}>
                                    <i className={`sort-icon ${!this.state.sortByOrder ? this.state.sortByPrice ? 'top' : 'bot' : ''}`}></i>
                                    {t("1ST")}
                                    </p>
                            </li>
                            <li className="horse-c-w">
                                <p>{t("SP")}</p>
                            </li>
                        </>
                        }
                        {
                            this.state.horseRacingMarket === 'forecast' &&
                            <>
                                <li className="horse-c-w">
                                    <p>{t("1ST")}</p>
                                </li>
                                <li className="horse-c-w">
                                    <p>{t("2ND")}</p>
                                </li>
                                <li className="horse-c-w">
                                    <p>{t("1ST or 2ND")}</p>
                                </li>
                            </>
                        }
                        {
                            this.state.horseRacingMarket === 'tricast' &&
                            <>
                                <li className="horse-c-w">
                                    <p>{t("1ST")}</p>
                                </li>
                                <li className="horse-c-w">
                                    <p>{t("2ND")}</p>
                                </li>
                                <li className="horse-c-w">
                                    <p>{t("3RD")}</p>
                                </li>
                                <li className="horse-c-w horse-last">
                                    <p>{t("1ST or 2ND or 3RD")}</p>

                                </li>
                            </>
                        }
                    </ul>
                    {fullData.sort(createSort(this.state.sortByOrder, this.state.sortByPrice)).map((event) => <HorseRacingEvent
                        type={event.type}
                        key={event.id}
                        event={event}
                        gameInfo={gameInfo}
                        market={this.state.horseRacingMarket}
                    />)
                    }
                </div>;
            }

            return <div className="racing-h-list-v greyhound-h-list-v">
                <div className="racing-h-list-v-title">
                    <div className="racing-h-comp greyhound-icon">
                        <p className="racing-icon-p"><span className={`flag-view-m icon-${gameInfo.region_alias.toLowerCase()}`}></span></p>
                        <p className="racing-h-comp-team-p">{gameInfo.team1_name}</p>
                        {
                            showEachWayInfo &&
                                <p className={'each-way-info'}>Each Way:
                                    <span> 1/{Object.values(gameInfo.market)[0].extra_info.EachWayK}</span>
                                    <span> {Object.values(gameInfo.market)[0].extra_info.EachWayPlace} Places</span>
                                </p>
                        }
                        {
                            status &&
                                <p className='status'>
                                    Status: { status }
                                </p>
                        }
                    </div>
                    <div className="market-selectors">
                        <p className={`selector ${this.state.horseRacingMarket === 'winner' && 'activeMarket'}`}
                            onClick={() => this.onChangeMarket('winner')}
                        >
                            <span>{t("Winner")}</span>
                        </p>
                        {
                            Object.values(marketData).map(market => ((
                                <p
                                    onClick={() => this.onChangeMarket(market.marketType)}
                                    className={`selector ${this.state.horseRacingMarket === market.marketType && 'activeMarket'}`}
                                >
                                    <span>{t(market.name)}</span>
                                </p>
                            )))
                        }
                        {
                            (gameInfo.game_info.IsForecastAvailable || gameInfo.game_info.IsTricastAvailable) &&
                            <p className={`selector ${this.state.horseRacingMarket === 'forecast' && 'activeMarket'}`}
                                onClick={() => this.onChangeMarket('forecast')}>
                                <span>{t("Forecast")}</span>
                            </p>
                        }
                        {
                            gameInfo.game_info.IsTricastAvailable &&
                            <p className={`selector ${this.state.horseRacingMarket === 'tricast' && 'activeMarket'}`}
                                onClick={() => this.onChangeMarket('tricast')}>
                                <span>{t("Tricast")}</span>
                            </p>
                        }
                    </div>
                </div>
                <ul>
                    <li className={`greyhound-price ${!hasPicture ? 'without-picture' : ''}`}>
                        <p>{t("NO.")}</p>
                    </li>
                    <li onClick={this.setMarketTypeToggle}>
                        {
                            hasPicture &&
                                <p className="set-greyhound">{this.state.trap ? t("Greyhound/Trap") : t("Trap/Greyhound")}</p>
                        }
                    </li>
                    {
                        hasPicture &&
                            <>
                                <li></li>
                                <li></li>
                            </>
                    }
                    {/* <li onClick={this.setMarketTypeToggle}>
                        <p className="set-greyhound">{this.state.trap ? "Trap" : "Greyhound"}</p>
                    </li> */}

                    {this.state.horseRacingMarket === 'winner' &&
                        <>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("1ST")}</p>
                            </li>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("SP")}</p>
                            </li>
                        </>
                    }
                    {
                        this.state.horseRacingMarket === 'forecast' &&
                        <>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("1ST")}</p>
                            </li>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("2ND")}</p>
                            </li>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("1ST or 2ND")}</p>
                            </li>
                        </>
                    }
                    {
                        this.state.horseRacingMarket === 'tricast' &&
                        <>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("1ST")}</p>
                            </li>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("2ND")}</p>
                            </li>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("3RD")}</p>
                            </li>
                            <li className="horse-c-w price greyhound-price-horse">
                                <p>{t("1ST or 2ND or 3RD")}</p>
                            </li>
                        </>
                    }
                    {
                        !(['winner', 'forecast', 'tricast'].includes(this.state.horseRacingMarket)) &&
                            <li className='horse-c-w price greyhound-price-horse'>
                                <p>{t('Odds')}</p>
                            </li>
                    }
                </ul>
                {
                    this.state.horseRacingMarket === 'matchBet'
                        ? <>
                            {
                                Object.values(marketData[this.state.horseRacingMarket]).filter(el => typeof el === 'object').map(item => {
                                    return (
                                        <>
                                            <ul className='match-bet-title'><li>Match Bet</li></ul>
                                            {
                                                item.list.sort((a, b) => a.original_order - b.original_order).map((event) => <GreyhoundsEvent
                                                    type={event.type}
                                                    key={event.id}
                                                    event={event}
                                                    hasPicture={hasPicture}
                                                    gameInfo={gameInfo}
                                                    setGameMarketType={this.state.trap}
                                                    isFavouriteType={(event === "Favourite")}
                                                    market={this.state.horseRacingMarket}
                                                />)
                                            }
                                        </>
                                    )
                                })
                            }
                          </>
                        : marketData[this.state.horseRacingMarket]
                            ? marketData[this.state.horseRacingMarket].list.sort((a, b) => a.original_order - b.original_order).map((event) => <GreyhoundsEvent
                                type={event.type}
                                key={event.id}
                                event={event}
                                hasPicture={hasPicture}
                                gameInfo={gameInfo}
                                setGameMarketType={this.state.trap}
                                isFavouriteType={(event === "Favourite")}
                                market={this.state.horseRacingMarket}
                            />)
                            : data.filter(item => item.marketType === (this.state.trap ? "Winner" : "TrapWinner")).sort((a, b) => a.original_order - b.original_order).map((event) => <GreyhoundsEvent
                                type={event.type}
                                key={event.id}
                                event={event}
                                gameInfo={gameInfo}
                                hasPicture={true}
                                setGameMarketType={this.state.trap}
                                isFavouriteType={(event === "Favourite")}
                                market={this.state.horseRacingMarket}
                            />)
                }
            </div>;
        }
        return <Loader />;
    }
}

const mapStateToProps = (state, ownProps) => {
    const key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestNextRacing(ownProps.params.sportId));

    return createSelector(
        [
            state => state.horseRacing.selections,
            state => state.swarmData.data[key] && state.swarmData.data[key],
            state => state.swarmData.loaded[key]
        ],
        (horseInfo, data, loaded) => {
            const dataArray = [];
            const now = Math.floor(Date.now() / 1000);
            const allData = {
                horseInfo
            }

            if (loaded && data) {
                Object.keys(data.region).filter(item => Object.prototype.hasOwnProperty.call(data.region, item)).forEach(regionId => {
                    const region = data.region[regionId];
                    Object.keys(region.competition).filter(item => Object.prototype.hasOwnProperty.call(region.competition, item)).forEach(competitionId => {
                        const competition = region.competition[competitionId];
                        Object.keys(competition.game).filter(item => Object.prototype.hasOwnProperty.call(competition.game, item)).forEach(gameId => {
                            const game = competition.game[gameId];
                            dataArray.push({ ...game, regionId, competitionId, gameId, regionAlias: region.alias, regionName: region.name });
                        });
                    });
                });

                allData.nextRacing = dataArray.sort((a, b) => a.start_ts - b.start_ts).filter(item => item.start_ts >= now)[0]
            }

            return allData
        });
};

export default withRouter(connect(mapStateToProps)(HorseRacingEventWrapper));